import ApolloClient from '@/packages/apollo-client'
import { isExpectedBackendError } from '@/packages/apollo-client/errors'
import Logger from '@/packages/logger'
import OnEvents from './Schema/Subscriptions/OnEvents.gql'

import { SUBSCRIBE_TO_EVENTS } from './action-types'
import { SET_SUBSCRIPTION_ERROR, SET_VIN_IMPORT_EVENT, SET_CREATE_FROM_DRAFT_EVENT } from './mutation-types'


export default {

	[SUBSCRIBE_TO_EVENTS] ({ commit, state }, payload) {
		const subscription = {
			query: OnEvents,
			variables: {
				sessionId: payload?.sessionId || state.sessionId,
				...(payload?.types ? { types: payload.types } : {})
			}
		}

		const sub = ApolloClient.subscribe(subscription).subscribe({
			next ({ data }) {
				if (data?.events && !data.errors) {
					const event = data.events
					if (event.__typename === 'ConfirmPartPicturesUploadEvent') {
						commit('Parts/SET_PROCESS_PICTURES_CALLBACK', event, { root: true })
					}
					if (event.__typename === 'ConfirmGroupedSalePicturesUploadEvent') {
						commit('GroupedSales/SET_PROCESS_PICTURES_CALLBACK', event, { root: true })
					}
					if (event.__typename === 'ExtractDataFromVinEvent' || event.__typename === 'ErrorEvent') {
						commit(SET_VIN_IMPORT_EVENT, event)
					}
					if (event.__typename === 'CreateGroupedSalePartsFromDraftEvent' || (event.__typename === 'ErrorEvent' && event.type === 'CREATE_GROUPED_SALE_PARTS_FROM_DRAFT')) {
						commit(SET_CREATE_FROM_DRAFT_EVENT, event)
					}
				} else if (data?.errors) {
					Logger.captureException(data.errors)
				}
			},
			error (err) {
				if (!isExpectedBackendError(err)) {
					Logger.captureException(err)
				}
				commit(SET_SUBSCRIPTION_ERROR, err)
			}
		})

		return sub // <-- IMPORTANT
	}
}
